"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useTranslations } from "@/providers/TranslationsProvider";
import { keyFor } from "@/lib/translationHelpers";
import type { DoctorLicence as Licence } from "@/types/doctor";

/**
 * A verified doctor's licence as patients see it: the licence type in the
 * visitor's language (e.g. "سازمان نظام پزشکی") and its number, which stays
 * left-to-right inside an RTL line.
 */
const DoctorLicence: React.FC<{
  licence: Licence;
  className?: string;
}> = t0 => {
  const $ = _c(14);
  const {
    licence,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    t
  } = useTranslations();
  let t2;
  if ($[0] !== licence.type) {
    t2 = keyFor(licence.type);
    $[0] = licence.type;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `join.licence types.${t2}.label`;
  let t4;
  if ($[2] !== t || $[3] !== t3) {
    t4 = t(t3, t("labels.licence", "Professional licence"));
    $[2] = t;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const label = t4;
  const t5 = `flex items-center gap-1.5 min-w-0 ${className}`;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="w-3.5 h-3.5 shrink-0 text-[#34C759]" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.6-4.02A12 12 0 0112 2.94a12 12 0 01-8.6 3.04A12 12 0 003 9c0 5.6 3.82 10.3 9 11.62C17.18 19.3 21 14.6 21 9c0-1.04-.13-2.05-.38-3.02z" /></svg>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== licence.number) {
    t7 = <bdi dir="ltr">{licence.number}</bdi>;
    $[6] = licence.number;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== label || $[9] !== t7) {
    t8 = <span className="truncate">{label}: {t7}</span>;
    $[8] = label;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t8) {
    t9 = <p className={t5}>{t6}{t8}</p>;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
export default DoctorLicence;